const DarkLightModeSwitch = ({ theme, setTheme }) => {
	const switchTheme = () => {
		if (theme === 'light') {
			setTheme('dark');
			document.documentElement.style.setProperty('--bg-color', '#333');
			document.documentElement.style.setProperty('--text-color', '#fff');
		} else {
			setTheme('light');
			document.documentElement.style.setProperty('--bg-color', '#fff');
			document.documentElement.style.setProperty('--text-color', '#333');
		}
	};

	const imgProps = {
		alt: theme === 'light' ? 'Normal People' : 'Netzhautablösibald',
		title: theme === 'light' ? 'Normal People' : 'Netzhautablösibald',
		className: 'icon',
		src: theme === 'light' ? './assets/icon--moon.svg' : './assets/icon--sun.svg',
	};

	return (
		<div className="dark-light-mode-switch">
			<button onClick={switchTheme} className="dark-light-mode-switch__button">
				<img {...imgProps} alt={imgProps.alt} />
			</button>
		</div>
	);
};

export default DarkLightModeSwitch;
